<template>
  <div id="app">
    <router-view />
    <!-- <NavTabbar v-if="showFooter" /> -->
    <ForceChangePasswordDialog />
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import tabBarList from "@/components/footer/tabBar.js";
import NavTabbar from "@/components/footer";
import watermark from "@/utils/watermark";
import ForceChangePasswordDialog from '@/components/ForceChangePasswordDialog/index.vue'

export default {
  created() {
    this.initApp();
  },
  components: {
    ForceChangePasswordDialog,
    NavTabbar,
  },
  computed: {
    // 展示footer的tabbar
    tabBarList() {
      return tabBarList.filter((tabBar) => !tabBar.isPrime).map((v) => v.path);
    },
    // 判断当前路由是否展示footer
    showFooter() {
      return this.tabBarList.includes(this.$route.path);
    },
  },
  mounted() {
    watermark({
      contentEl: document.body,
      text: "红山教育网",
    });
    this.plusReady(()=>{
      this.$store.dispatch('SetVersion', plus.runtime.version)
    })
  },
  methods: {
    // 初始化应用
    initApp() {
      // 检查用户登录状态
      //#ifdef H5
      // this.checkLogin();
      //#endif
      document.addEventListener('UniAppJSBridgeReady', () => {
        this.$uni.getEnv((data) => {
          // 如果在app环境中跳转到对应网址
          if (data.plus) {
            window.location.href = window.location.href.replace('https://1zt-mobile.hongshanjy.cn', 'https://1zt-app.hongshanjy.cn')
          }
        })
      })
      // 取出Token
      this.$store.dispatch('SetToken', getToken())
    },
    checkLogin() {
      if (!getToken()) {
        window.location.replace(`${location.origin}#/login`);
      }
    },
  },
};
</script>

<style>
#app {
  font-family: "PingFangSC-Regular", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  overflow: scroll;
}
.vant-widget {
  font-size: 18px;
}

.touch-hover-active {
  background-color: #ddd;
}
</style>
